/*
 * Hootie Hoo size & fit guidance.
 * When the combined-listings app replaces the theme's size picker with its own
 * buttons, the theme's picker stays in the page (hidden) and keeps updating.
 * This copies the fit guidance and size-chart link into view and labels the
 * app's size buttons with the ages from the theme's picker.
 */
(function () {
  function sizeLabelFor(themePicker, value) {
    var inputs = themePicker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) {
        var label = themePicker.querySelector('label[for="' + inputs[i].id + '"]');
        if (!label) return null;
        var size = label.querySelector('.hh-size-btn__size');
        var age = label.querySelector('.hh-size-btn__age');
        if (!size || !age) return null;
        return { size: size.textContent.trim(), age: age.textContent.trim() };
      }
    }
    return null;
  }

  function sync(container) {
    var app = container.querySelector('.mpg-swatch');
    var themePicker = container.querySelector('variant-picker');
    if (!app || !themePicker) return;

    // 1. Age labels on the app's size buttons
    var buttons = app.querySelectorAll('.mpg-swatch__option[o-value]');
    buttons.forEach(function (btn) {
      if (btn.querySelector('.hh-size-btn__age')) return;
      var info = sizeLabelFor(themePicker, btn.getAttribute('o-value'));
      if (!info) return;
      btn.classList.add('hh-size-btn', 'hh-size-btn--app');
      btn.textContent = '';
      var s = document.createElement('span');
      s.className = 'hh-size-btn__size';
      s.textContent = info.size;
      var a = document.createElement('span');
      a.className = 'hh-size-btn__age';
      a.textContent = info.age;
      btn.appendChild(s);
      btn.appendChild(a);
      btn.setAttribute('aria-label', info.size + ', ' + info.age);
    });

    // 2. Fit guidance below the app's size buttons
    var source = themePicker.querySelector('.hh-fit');
    var slot = container.querySelector('.hh-fit--app');
    if (source) {
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'hh-fit hh-fit--app';
        themePicker.insertAdjacentElement('afterend', slot);
      }
      if (slot.innerHTML !== source.innerHTML) slot.innerHTML = source.innerHTML;
      slot.hidden = false;
    } else if (slot) {
      slot.hidden = true;
    }

    // 3. Size chart link next to the app's "Size" heading
    if (!container.querySelector('.hh-chart-link--app')) {
      var opener = themePicker.querySelector('modal-opener.open-size-chart');
      var sizeSet = null;
      buttons.forEach(function (b) {
        if (!sizeSet && b.classList.contains('hh-size-btn--app')) sizeSet = b.closest('.mpg-swatch__option-set');
      });
      if (opener && sizeSet) {
        opener.classList.add('hh-chart-link--app');
        sizeSet.classList.add('hh-size-set--app');
        sizeSet.appendChild(opener);
      }
    }
  }

  function syncAll() {
    document.querySelectorAll('.variant-picker').forEach(function (c) {
      if (c.querySelector('variant-picker')) sync(c);
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      syncAll();
    });
  }

  function start() {
    syncAll();
    document.addEventListener('variant:changed', queue);
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
